import type { ReactNode } from "react";
import type { PlanItem } from "../types";
import { CheckIcon } from "../../shared/components/icons";
import styles from "./PlanView.module.css";

interface PlanViewProps {
  readonly items: PlanItem[];
}

function statusGlyph(status: PlanItem["status"]): ReactNode {
  if (status === "completed") return <CheckIcon />;
  if (status === "in_progress") return "◐";
  return "○";
}

/**
 * Read-only live plan (chat v2, AIVA-5929). Renders the agent's task list
 * from `plan_update` snapshots inside the assistant bubble — visible while
 * the turn streams so the user can watch multi-step progress. No
 * interactivity by design: the stop button remains the user's only control.
 */
export function PlanView({ items }: Readonly<PlanViewProps>) {
  if (items.length === 0) return null;
  return (
    <div className={styles.plan} aria-label="Plan">
      {items.map((item) => (
        <div key={item.content} className={styles.planItem} data-status={item.status}>
          <span className={styles.planGlyph} aria-hidden="true">
            {statusGlyph(item.status)}
          </span>
          <span className={item.status === "completed" ? styles.planTextDone : styles.planText}>
            {item.content}
          </span>
        </div>
      ))}
    </div>
  );
}
